<template>
<div class="container">
    <div class="row row-cards">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-4">
            <div class="card">
              <div class="card-body">
                <form v-on:submit.prevent="submitAdd" class="m-item">
                  <div class="form-group">
                    <label class="form-label">Item Name</label>
                    <div class="input-group">
                      <input v-model="itemName" type="text" class="form-control" placeholder="Enter name" minlength="2" required>
                      <span class="input-group-append">
                        <button class="btn btn-primary" type="submit">Add</button>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Estimated Expenses</div>
                <div class="display-4 font-weight-bold mb-4">S${{total.estimated | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-green" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
           <div class="col-sm-4">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Actual Expenses</div>
                <div class="display-4 font-weight-bold mb-4">S${{total.actual | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-green" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="col-12" v-for="(group, gindex) in groups" :key="gindex">
        <div class="card">
          <div class="card-header">
            <button type="button" class="btn btn-icon btn-primary mr-4" @click="addItem(group)">
              <i class="fe fe-plus"></i>
            </button>
            <button type="button" class="btn btn-icon btn-danger mr-4" @click="deleteGroup(gindex)">
              <i class="fe fe-trash"></i>
            </button>
            <h4 class="card-title">{{group.name}}</h4>
          </div>
          <div class="table-responsive">
            <table id="tbl-orgs" class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <th class="w-1">#</th>
                  <th>Name</th>
                  <th>Estimated Amount</th>
                  <th>Actual Amount</th>
                  <th class="text-center">Percentage</th>
                  <th>Description</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in group.items" :key="index">
                  <td><span class="text-muted">{{index + 1}}</span></td>
                  <td>
                    <div class="input-group">
                      <input type="text" v-model="item.name" class="form-control" name="example-text-input" placeholder="Text..">
                    </div>
                    <span hidden>{{item.name}}</span>
                  </td>
                  <td class="m-amount">
                    <div class="input-group">
                      <span class="input-group-prepend">
                        <span class="input-group-text">S$<span hidden>{{item.estimatedAmount}}</span></span>
                      </span>
                      <input type="number" min="0" v-model="item.estimatedAmount" class="form-control text-right"  aria-label="Amount (to the nearest dollar)">
                    </div>
                  </td>
                  <td class="m-amount">
                    <div class="input-group">
                      <span class="input-group-prepend">
                        <span class="input-group-text">S$ <span hidden>{{item.actualAmount}}</span></span>
                      </span>
                      <input type="number" min="0" v-model="item.actualAmount" class="form-control text-right"  aria-label="Amount (to the nearest dollar)">
                    </div>
                  </td>
                  <td class="text-center">
                    <CircleProgress :percent="item.actualAmount/getGroupAmounts(group).actual*100 | limit(4)" :percentValue="item.actualAmount/getGroupAmounts(group).actual"/>
                  </td>
                  <td>
                    <textarea rows="2" class="form-control" placeholder="Enter description" value="Mike"  v-model="item.description"></textarea>
                    <span hidden>{{item.description}}</span>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-icon btn-danger" @click="deleteItem(group, index)"><i class="fe fe-trash"></i></button>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td class="text-right">
                    <strong>S${{getGroupAmounts(group).estimated | currency}}</strong>
                  </td>
                  <td class="text-right">
                    <strong>S${{getGroupAmounts(group).actual | currency}}</strong>
                  </td>
                  <td class="text-center">
                    <CircleProgress :percent="getGroupAmounts(group).actual/total.actual*100 | limit(4)" :percentValue="getGroupAmounts(group).actual/total.actual"/>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleProgress from '@/components/CircleProgress'
import dataUtil from '@/util/DataUtil'
export default {
  components: {
    CircleProgress
  },
  name: 'ExpensePage',
  created () {
    this.groups = this.$store.getters['expense/getGroups']
  },
  data () {
    return {
      itemName: '',
      groups: []
    }
  },
  methods: {
    getGroupAmounts (group) {
      return dataUtil.getGroupAmounts(group)
    },
    deleteItem (group, index) {
      dataUtil.deleteItem(group, index)
    },
    addItem (group) {
      dataUtil.addItem(group)
    },
    deleteGroup (index) {
      dataUtil.deleteGroup(this.groups, index)
    },
    submitAdd () {
      this.$store.dispatch('expense/addGroup', {itemName: this.itemName})
    }
  },
  computed: {
    total () {
      return this.$store.getters['expense/getTotal']
    }
  }
}
</script>

<style scoped>
.m-amount {
  width: 140px;
}
.m-item {
  height: 104px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ExpensePage.vue